import React, { useEffect, useState } from "react";
import theme from "../../Styles/theme";
import { AlertTitle, Button, Container, DivButtons, Input, RecuperaButton, Span } from "./styles";
import Modal from "react-modal";
import { PerfilInput } from "../PerfilInput";
import { SignInButton } from "../Buttons/SingnInButton";
import api from "../../Services/api";
import { ModalLoader } from "../ModalLoader";
import { Alert } from "../Error/Alert";
import axios from "axios";
import { baseUrlApiNotoficacoes } from "../../Utils/baseUrl";
import { idText } from "typescript";
import { IFuncionarioCartorioList } from "../../Hooks/funcionarioCartorio";
import { IFuncionarioPrefeituraList } from "../../Hooks/funcionarioPrefeitura";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  type: "Funcionario-Cartorio" | "Funcionario-Prefeitura" | "Cartorio";
}

export function EsqueciMinhaSenhaModal({ open, onClose, type }: Props) {
  const [cpf, setCpf] = useState("");
  const [titleButton, setTitleButon] = useState("");
  const [buttons, setButtons] = useState({} as IFuncionarioCartorioList[] | IFuncionarioPrefeituraList[]);
  const [id, setId] = useState(0);
  const [modalExecucao, setModalExecucao] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });
  async function busca() {
    try {
      setLoading(true);
      if (type == "Cartorio") {
        const { data } = await api.get(`/cartorio/${cpf}`);
        if (data.ID) {
          setTitleButon(data.NOME);
          setId(data.ID);
        } else {
          setError({
            title: "Ops",
            message:
              "Nenhum cartório foi encontrado nenhum cartório com esta chave!",
          });
        }
      }

      if (type == "Funcionario-Cartorio") {
        const { data } = await api.get<IFuncionarioCartorioList[]>(`/funcionario-cartorio/por-cpf/${cpf}`);
        if (data && data.length > 0) {
         console.log(data)
         setButtons(data)

         console.log(buttons)
        } else {
          setError({
            title: "Ops",
            message:
              "Nenhuma conta foi encontrada com esta chave!",
          });
        }
      }


      if (type == "Funcionario-Prefeitura") {
        const { data } = await api.get<IFuncionarioCartorioList[]>(`/funcionario-prefeitura/por-cpf/${cpf}`);
        if (data && data.length > 0) {
         console.log(data)
         setButtons(data)

         console.log(buttons)
        } else {
          setError({
            title: "Ops",
            message:
              "Nenhuma conta foi encontrada com esta chave!",
          });
        }
      }
    } catch (error) {
      setError({
        title: "Ops",
        message: "Não foi possível	 encontrar o usuário",
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    console.log('AQUI:\n',buttons)
  },[buttons])
  async function recuperar() {
    setModalExecucao(false);
    try {
      setLoading(true);
      baseUrlApiNotoficacoes;
      if (type == "Cartorio") {
        const { data } = await axios.get(
          `${baseUrlApiNotoficacoes}/cartorio/recuperar-senha/cartorio/${id}`
        );
        //OBS ISSO É UMA GAMBIARRA SOMENTE PARA EXIBIR RECUPERAÇÃO DO EMAIL
        setError({
          title: "Recuperação efetuada com sucesso!",
          message: `Uma nova senha foi gerada e enviada ao endereço de email: ${data}`,
        });

        
      }
      if(type == "Funcionario-Cartorio"){
        const { data } = await axios.get(
          `${baseUrlApiNotoficacoes}/cartorio/recuperar-senha/funcionario/${id}`
        );
        //OBS ISSO É UMA GAMBIARRA SOMENTE PARA EXIBIR RECUPERAÇÃO DO EMAIL
        setError({
          title: "Recuperação efetuada com sucesso!",
          message: `Uma nova senha foi gerada e enviada ao endereço de email: ${data}`,
        });

      }

      if(type == "Funcionario-Prefeitura"){
        const { data } = await axios.get(
          `${baseUrlApiNotoficacoes}/prefeitura/recupera-senha/funcionario/${id}`
        );
        //OBS ISSO É UMA GAMBIARRA SOMENTE PARA EXIBIR RECUPERAÇÃO DO EMAIL
        setError({
          title: "Recuperação efetuada com sucesso!",
          message: `Uma nova senha foi gerada e enviada ao endereço de email: ${data}`,
        });

      }
    } catch (error) {
      setError({
        title: "Ops",
        message: "Não foi possível	 recuperar sua senha!",
      });
    } finally {
      setLoading(false);
    }
  }

  function ModalExecucao() {
    return (
      <Modal
        isOpen={modalExecucao}
        onRequestClose={() => {}}
        style={customStyles}
      >
        <Container>
          <AlertTitle>Deseja mesmo recuperar a senha de {titleButton}?</AlertTitle>
          <DivButtons>
            <Button
              onClick={() => {
                setId(0);
                setTitleButon("");
                onClose();
                setModalExecucao(false)
               
              }}
            >
              CANCELAR
            </Button>
            <Button onClick={recuperar}>CONFIRMAR</Button>
          </DivButtons>
        </Container>
      </Modal>
    );
  }

  useEffect(() => {
    setId(0);
    setTitleButon("");
  },[open])

  function renderButtons(){
    console.log("AQUI DE NOVO", buttons)
    if(buttons)
      if(buttons.length > 0)
        return buttons.map((item)=>{
        return<RecuperaButton onClick={() => {
            setId(item.ID)
            setTitleButon(item.NOME)
            setModalExecucao(true)}}>
          {item.NOME} - <Span>{item.ENTIDADE}</Span>
          </RecuperaButton>
        

        })
         
        
  
  }

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <Container>
        {id != 0 || buttons.length > 0 ? (
          <>
          { type == "Funcionario-Cartorio"  || type=="Funcionario-Prefeitura"?
          renderButtons()
            :    <RecuperaButton onClick={() => setModalExecucao(true)}>
            {titleButton}
          </RecuperaButton>}
       
          </>
        ) : (
          <>
            
            {type == "Cartorio" || type == "Funcionario-Cartorio"|| type =="Funcionario-Prefeitura" ? (
              <Input
                value={cpf}
                placeholder={"CPF | CNPJ"}
                disabled={false}
                onChange={(ev) => {
                  setCpf(ev.target.value);
                }}
              />
            ) : (
              ""
            )}
            <SignInButton
              text="BUSCAR"
              enable={false}
              type={"cadastro"}
              execute={busca}
            />
          </>
        )}
      </Container>
      <ModalLoader loading={loading} />
      <Alert
        title={error.title}
        message={error.message}
        open={error.message.length > 0}
        onClose={() => {
          setError({ title: "", message: "" });
        }}
      />
      {ModalExecucao()}
    </Modal>
  );
}
